import React, { useEffect, useId, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getSkin, SKINS } from '../utils/skins';
import { useSkinSettings } from './SkinContext';
import ThemeIcon from './ThemeIcon';
import AnimatedDisclosure from './AnimatedDisclosure';
import './SkinPicker.css';

export default function SkinPicker({ skin: selected, period: selectedPeriod, onSkinChange: change, onSelect, className = '' }) {
  const settings = useSkinSettings();
  const skin = selected || settings.skin;
  const period = selectedPeriod || settings.period;
  const onSkinChange = change || settings.onSkinChange;
  const [open, setOpen] = useState(false);
  const picker = useRef(null);
  const trigger = useRef(null);
  const id = `skin-menu-${useId().replace(/:/g, '')}`;
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    if (!open) return undefined;
    const dismiss = event => { if (!picker.current?.contains(event.target)) setOpen(false); };
    const escape = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        trigger.current?.focus();
      }
    };
    const viewport = window.matchMedia('(min-width: 769px)');
    const resize = () => setOpen(false);
    document.addEventListener('pointerdown', dismiss, { passive: true });
    document.addEventListener('keydown', escape, true);
    viewport.addEventListener?.('change', resize);
    return () => {
      document.removeEventListener('pointerdown', dismiss);
      document.removeEventListener('keydown', escape, true);
      viewport.removeEventListener?.('change', resize);
    };
  }, [open]);
  const periodLabel = { day: '白天', dusk: '黄昏', night: '夜晚' }[period] || '白天';
  return <div className={`skin-picker ${className}`} ref={picker}>
    <button type="button" className={`nav-link skin-toggle${open ? ' active' : ''}`} ref={trigger} onClick={() => setOpen(value => !value)} aria-label={`选择皮肤，当前${getSkin(skin).name}`} aria-expanded={open} aria-controls={id}>
      <ThemeIcon name="skin" skin={skin} period={period} /><span>皮肤</span>
    </button>
    <AnimatedDisclosure id={id} open={open} className="skin-menu-disclosure">
    <div className="skin-menu" role="group" aria-label="博客皮肤" style={{ position: 'relative', inset: 'auto', width: '100%', boxSizing: 'border-box', animation: 'none', transition: 'none' }}>
      <div className="skin-menu-heading">选择皮肤 <span>SKIN</span></div>
      {SKINS.map(option => <button key={option.id} type="button" className={`skin-option${skin === option.id ? ' selected' : ''}`} aria-pressed={skin === option.id} onClick={() => { setOpen(false); trigger.current?.focus({ preventScroll: true }); onSelect?.(); onSkinChange(option.id); }}>
        <span className={`skin-swatch skin-swatch-${option.id === 'dynamic' ? period : option.id}`} aria-hidden="true" />
        <span className="skin-option-copy"><strong>{option.name}</strong><small>{option.description}{option.id === 'dynamic' ? ` · 此刻${periodLabel}` : ''}</small></span>
        <span className="skin-option-check" aria-hidden="true"><ThemeIcon name="check" /></span>
      </button>)}
    </div>
    </AnimatedDisclosure>
  </div>;
}
